// Homepage banner: slides in from the right, 5s after the visitor
// scrolls past 20% of the viewport. Reappears on every visit (no
// persistence); the close button only dismisses the current view.
(function () {
    var banner = document.querySelector('.promo-banner');

    if (!banner) {
        return;
    }

    var DELAY = 5000;
    var armed = false;
    var timer = null;

    function threshold() {
        // 20dvh — mirror of the CSS trigger point.
        return window.innerHeight * 0.2;
    }

    function reveal() {
        banner.classList.add('is-visible');
    }

    function onScroll() {
        if (armed || window.scrollY <= threshold()) {
            return;
        }

        armed = true;
        window.removeEventListener('scroll', onScroll);
        timer = window.setTimeout(reveal, DELAY);
    }

    function dismiss(event) {
        event.preventDefault();
        event.stopPropagation();

        if (timer) {
            window.clearTimeout(timer);
        }

        banner.classList.remove('is-visible');
        banner.classList.add('is-dismissed');
    }

    window.addEventListener('scroll', onScroll, {passive: true});

    var close = banner.querySelector('.promo-banner__close');

    if (close) {
        close.addEventListener('click', dismiss);
    }
})();
